import { render, staticRenderFns } from "./pointItem.vue?vue&type=template&id=f2298f5c"
import script from "./pointItem.vue?vue&type=script&lang=js"
export * from "./pointItem.vue?vue&type=script&lang=js"
import style0 from "./pointItem.vue?vue&type=style&index=0&id=f2298f5c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports